import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { isEmpty as l } from "es-toolkit/compat";
const f = c((r, n) => {
  const { show: s = !1, navItems: e, actionBarItems: d, onDropdownClick: p, onItemClick: i } = r;
  return l(e) && l(d) ? null : /* @__PURE__ */ t("li", { className: `CollapsedDropdown dropdown ${s ? "open" : ""}`, ref: n, children: [
    /* @__PURE__ */ o(
      "a",
      {
        id: "basic-nav-dropdown",
        role: "button",
        className: "dropdown-toggle text-color-gray",
        "aria-haspopup": "true",
        "aria-expanded": "true",
        onClick: p,
        children: /* @__PURE__ */ o("span", { className: "rioglyph rioglyph-option-horizontal", "aria-hidden": "true" })
      }
    ),
    /* @__PURE__ */ o("ul", { className: "dropdown-menu", role: "menu", "aria-labelledby": "basic-nav-dropdown", children: e.map((a) => /* @__PURE__ */ o("li", { className: "submodule", onClick: i, "data-nav-item-key": a.key, children: a.route }, a.key)) })
  ] }, "collapsed-dropdown");
});
export {
  f as default
};
//# sourceMappingURL=CollapsedNavItem.js.map
